(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('HandbookMergeHeader', HandbookMergeHeader);

    HandbookMergeHeader.$inject = ['$resource', 'DateUtils'];

    function HandbookMergeHeader ($resource, DateUtils) {
        var resourceUrl =  'api/handbook-merge-headers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startTime = DateUtils.convertDateTimeFromServer(data.startTime);
                        data.finishTime = DateUtils.convertDateTimeFromServer(data.finishTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
